module.exports = __webpack_public_path__ + "img/my-member-select.6610a06b.svg";